import ephent from './image/ephent.png';
import book from './image/book.png';
import dictionary from './image/dictionary.png';
import space from './image/space.png';
import recipe from './image/recipe.png';
import doctor from './image/doctor.png';

export const works = [
  {
    title: 'Ephent',
    description: 'Ephent allows all its users to create and manage events. Be informed of all the events created around you, make new friends and build a network.',
    languageTools: ['Kotlin', 'Golang', 'gorilla/mux', 'MongoDB', 'Google Cloud Platform', 'TDD', 'Heroku'],
    liveDemo: 'https://play.google.com/store/apps/details?id=com.github.kosher9.wehere',
    image: ephent,
  },
  {
    title: 'Recipe App',
    description: 'The Recipe app keeps track of all your recipes, ingredients, and inventory. It will allow you to save ingredients, keep track of what you have, create recipes, and generate a shopping list based on what you have and what you are missing from a recipe.',
    languageTools: ['Ruby', 'Ruby on Rails', 'RSpec', 'PosgreSQL', 'Devise'],
    liveDemo: 'https://polar-lake-16717.herokuapp.com/',
    linkGithub: 'https://github.com/kosher9/Recipe-app',
    image: recipe,
  },
  {
    title: 'Meet Doctor',
    description: 'This application is based booking an appointment with prominent Doctors around the world, you need just to login then book a reservation, after that you can log out or check all your reservations.',
    languageTools: ['ReactJS', 'Redux', 'JavaScript', 'Jest', 'REST API', 'Ruby', 'Ruby on Rails', 'RSpec', 'PosgreSQL', 'Devise'],
    liveDemo: 'https://meet-a-doctor.netlify.app/',
    linkGithub: 'https://github.com/kosher9/meet_doctor_front_end',
    image: doctor,
  },
  {
    title: 'Book store',
    description: 'This is your online library. Book store is a web application allowing you to save all kinds of books that interest you. Save books by category for better organization. Delete books that no longer interest you.',
    languageTools: ['ReactJS', 'Redux', 'JavaScript', 'Jest', 'REST API'],
    liveDemo: 'https://harmonious-cucurucho-b4c5ce.netlify.app',
    linkGithub: 'https://github.com/kosher9/Bookstore',
    image: book,
  },
  {
    title: 'Dictionary',
    description: 'Dictionary is a command line interface application (CLI) that allows you to have your own dictionary. Create your own dictionary, add whatever you want to it, consult your dictionary and update your entries.',
    languageTools: ['Golang', 'BadgerDB', 'CLI application', 'Test'],
    linkGithub: 'https://github.com/kosher9/dictionary',
    image: dictionary,
  },
  {
    title: 'Space Travelers\' Hub',
    description: 'Want to go to Mars? This application allows you to book your flight. This application is based on the Space X API. The state of the application is managed using redux. Do not hesitate, make your first reservations.',
    languageTools: ['ReactJs', 'Redux', 'TailwindCSS', 'Jest', 'Jest-test'],
    liveDemo: 'https://space-travelers-hub-202.netlify.app/',
    linkGithub: 'https://github.com/kosher9/space_traveler_hub',
    image: space,
  },
];
export default works;
